export const Nice = () => <span className="nice-word">NICE</span>;

export const niceText = (s) => {
  if (typeof s !== "string" || !s.includes("NICE")) return s;
  return s.split("NICE").flatMap((part, i) => (i ? [<Nice key={i} />, part] : [part]));
};
